// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2R0vf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2WjGg"};